var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "not-found-content" }, [
      _c("div", { staticClass: "banner-text text-center" }, [
        _c("h1", { staticClass: "font-weight-bold" }, [_vm._v(" 404 ")]),
        _c("h4", { staticClass: "mt-3 mb-1" }, [
          _vm._v(" The page was not found. "),
        ]),
      ]),
      _c("div", { staticClass: "banner-img" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }